import {
  FormSectionState,
  FormSectionStateArray,
  FormState,
} from '@navstation-portal/reporting/data-model/vessel-report';
import { FuelSpecFormState } from '@navstation-portal/reporting/data-model/vessel-report';
import { signalStoreFeature, type } from '@ngrx/signals';
import { on, withReducer } from '@ngrx/signals/events';
import { initStateField } from '../../utils/store.utility';
import { consumptionsEvents } from './consumptions-events';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function withConsumptionsReducer<_>() {
  return signalStoreFeature(
    type<{ state: { formState: FormState } }>(),
    withReducer(
      on(consumptionsEvents.clearFuelSpec, ({ payload: index }) => (state) => {
        const formState = state['formState'];

        const fuelSpecs = formState['fuelSpecs'] as FormSectionState;
        const fsEntries = (fuelSpecs['entries'] as FormSectionStateArray) || [];
        const fsEntryToClear = fsEntries[index] as FuelSpecFormState;

        const totalConsumptions = formState['totalConsumptions'] as FormSectionState;
        const tcEntries = (totalConsumptions['entries'] as FormSectionStateArray) || [];

        const auxEngines = formState['auxEngineConsumptions'] as FormSectionState;
        const aeEntries = (auxEngines['entries'] as FormSectionStateArray) || [];

        const boilers = formState['boilerConsumptions'] as FormSectionState;
        const boilerEntries = (boilers['entries'] as FormSectionStateArray) || [];

        return {
          formState: {
            ...formState,
            fuelSpecs: {
              entries: [
                ...fsEntries.slice(0, index),
                {
                  fuelType: fsEntryToClear.fuelType,
                  lcv: initStateField<number>(),
                  sulphur: initStateField<number>(),
                  density: initStateField<number>(),
                  fuelTemp: initStateField<number>(),
                  viscosity: initStateField<number>(),
                },
                ...fsEntries.slice(index + 1),
              ],
            },
            totalConsumptions: {
              entries: [
                ...tcEntries.slice(0, index),
                {
                  mainEngine: initStateField<number>(),
                  auxEngines: initStateField<number>(),
                  boiler: initStateField<number>(),
                  igGenerator: initStateField<number>(),
                  incinerator: initStateField<number>(),
                  dpp: initStateField<number>(),
                  otherEngines: initStateField<number>(),
                  cargoRelated: initStateField<number>(),
                  total: initStateField<number>(),
                },
                ...tcEntries.slice(index + 1),
              ],
            },
            auxEngineConsumptions: {
              entries: [
                ...aeEntries.slice(0, index),
                {
                  basicLoad: initStateField<number>(10),
                  ballastOperations: initStateField<number>(),
                  cargoHeating: initStateField<number>(),
                  tankCleaning: initStateField<number>(),
                  cargoDischarging: initStateField<number>(),
                  inertGasSystems: initStateField<number>(),
                  bunkerHeating: initStateField<number>(),
                },
                ...aeEntries.slice(index + 1),
              ],
            },
            boilerConsumptions: {
              entries: [
                ...boilerEntries.slice(0, index),
                {
                  basicLoad: initStateField<number>(0),
                  ballastOperations: initStateField<number>(),
                  cargoHeating: initStateField<number>(),
                  tankCleaning: initStateField<number>(),
                  cargoDischarging: initStateField<number>(),
                  inertGasSystems: initStateField<number>(),
                  bunkerHeating: initStateField<number>(),
                },
                ...boilerEntries.slice(index + 1),
              ],
            },
          },
        };
      })
    )
  );
}
